import Breadcrumb from '@/components/feature/Breadcrumb';
import WorksExplorer from './components/WorksExplorer';
import JsonLd from '@/components/base/JsonLd';
import { useSeo, buildAbsoluteUrl } from '@/hooks/useSeo';
import { works } from '@/mocks/works';

const title = '作品合集 - 黑料大赛参赛作品按热度整理 | 黑料大赛';
const description =
  '黑料大赛作品合集页，收录全部通过复核的参赛作品，支持按主题分类筛选与热度、最新、围观排序，快速找到你想看的爆料盘点内容。';
const keywords = '黑料大赛作品合集,黑料大赛参赛作品,黑料大赛热门作品,作品列表';

export default function Works() {
  useSeo({ title, description, keywords, path: '/works' });

  const pageUrl = buildAbsoluteUrl('/works');
  const schema = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'CollectionPage',
        name: title,
        url: pageUrl,
        description,
        inLanguage: 'zh-CN',
      },
      {
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: '首页', item: buildAbsoluteUrl('/') },
          { '@type': 'ListItem', position: 2, name: '作品合集', item: pageUrl },
        ],
      },
      {
        '@type': 'ItemList',
        name: '黑料大赛参赛作品列表',
        numberOfItems: works.length,
        itemListElement: works.map((work, index) => ({
          '@type': 'ListItem',
          position: index + 1,
          name: work.title,
          url: buildAbsoluteUrl(`/works/${work.id}`),
        })),
      },
    ],
  };

  return (
    <>
      <JsonLd data={schema} />
      <div className="w-full border-b border-background-200 bg-background-100">
        <div className="mx-auto w-full px-4 py-10 md:px-6 md:py-14">
          <Breadcrumb items={[{ label: '首页', to: '/' }, { label: '作品合集' }]} />
          <h1 className="mt-4 font-heading text-3xl font-black text-foreground-950 md:text-4xl">
            黑料大赛作品合集
          </h1>
          <p className="mt-4 max-w-2xl font-body text-sm leading-relaxed text-foreground-600 md:text-base">
            这里收录全部通过复核的参赛作品。可以用主题分类快速缩小范围，也可以按热度、最新或围观数排序，
            想找特定的选手或事件，直接搜关键词就行。
          </p>
        </div>
      </div>

      <div className="mx-auto w-full px-4 py-10 md:px-6 md:py-14">
        <WorksExplorer />
      </div>
    </>
  );
}